import { useCallback, useEffect, useRef, useState } from 'react';

interface Cooldown {
  /** Секунд осталось (0, когда неактивен). */
  readonly remaining: number;
  readonly active: boolean;
  /** Запустить отсчёт заново. */
  readonly start: () => void;
}

/**
 * Кулдаун для кнопок повторной отправки (письмо подтверждения / сброс пароля),
 * чтобы пользователь не спамил бэкенд. Тикает раз в секунду, сам останавливается на нуле.
 */
export function useCooldown(seconds: number): Cooldown {
  const [remaining, setRemaining] = useState(0);
  const intervalRef = useRef<number | undefined>(undefined);

  const clear = useCallback(() => {
    if (intervalRef.current !== undefined) {
      window.clearInterval(intervalRef.current);
      intervalRef.current = undefined;
    }
  }, []);

  const start = useCallback(() => {
    clear();
    setRemaining(seconds);
    intervalRef.current = window.setInterval(() => {
      setRemaining((value) => {
        if (value <= 1) {
          clear();
          return 0;
        }
        return value - 1;
      });
    }, 1000);
  }, [seconds, clear]);

  useEffect(() => clear, [clear]);

  return { remaining, active: remaining > 0, start };
}
